<div class="approval-box">
  <div>
    <h3>{{ action | uppercase }} REQUEST</h3>
  </div>

  <div>
    <textarea
      class="form-control shadow-none"
      [(ngModel)]="comment"
      cols="40"
      [placeholder]="action.toLowerCase() === 'approve' ? 'Enter your comment (optional)' : 'Enter your comment'"
      rows="4"
    >
    </textarea>
  </div>

  <div *ngIf="!hideSubmitButton">
    <form (ngSubmit)="submit()">
      <button class="btn submit" type="submit">Submit</button>
    </form>
  </div>
</div>
